// istanbul ignore file
const resolveHostMeetingPrepRemote = (loadedModule) => (
  loadedModule?.default || loadedModule
)

let hostMeetingPrepRemotePromise = null

export const loadHostMeetingPrepRemote = () => {
  if (!hostMeetingPrepRemotePromise) {
    hostMeetingPrepRemotePromise = (async () => {
      try {
        const loadedModule = await import(
          /* webpackChunkName: "oap_web_host_meeting_prep" */
          'oap_web/HostMeetingPrep',
        )

        return resolveHostMeetingPrepRemote(loadedModule)
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[loadHostMeetingPrepRemote] dynamic import of oap_web/HostMeetingPrep failed', error)
        }
        return null
      }
    })()
  }

  return hostMeetingPrepRemotePromise
}
